let host = location.host;
var Run = 'https://system.alanabe.com';

if (location.href.indexOf('/help/fc_help.aspx') != -1) {
    $('body, html').hide();
    if (Run.indexOf(host) > -1) {
        location.href = 'https://fc.alanabe.com/faq/';
    }
    else {
        location.href = 'https://fc.alanabe.com/faq/';
    }
}
if (location.href.indexOf('/help/help.aspx') != -1) {
    $('body, html').hide();
    if (Run.indexOf(host) > -1) {
        location.href = 'https://ec.alanabe.com/faq/';
    }
    else {
        location.href = 'https://ec.alanabe.com/faq/';
    }
}


// プライバシーポリシーのリダイレクト
if (location.href.indexOf('privacy.aspx') != -1) {
  $('body, html').hide();

  location.href = 'https://www.axelentermedia.co.jp/privacy/';
}


$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');
    const pageId = 'ecalanabecom';

    if (bodyId === 'Register') {
        pageRegister();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'fcJoinEntry') {
        fcJoinEntry()
    } else if (bodyId === 'fcKiyaku') {
        fcKiyaku();
    } else if (bodyId === 'com_help') {
        com_help()
    } else if (bodyId === 'com_kiyaku') {
        com_kiyaku()
    } else if (bodyId === 'com_tokutei') {
        com_tokutei()
    } else if (bodyId === 'com_contact') {
        com_contact()
    } else if (bodyId === 'contact') {
        contact()
    } else if (bodyId === 'fc_contact') {
        fc_contact()
    } else if (bodyId === 'CheckOut') {
        CheckOut()
    } else if (bodyId === 'fcJoin') {
        fcJoin()
    }else if (bodyId === 'fcPay') {
        fcPay()
    }
    else if (bodyId === 'help07') {
        help07();
    } else if (bodyId === 'kiyaku') {
        Kiyaku(pageId);
    } else if (bodyId === 'tokutei') {
        Tokutei(pageId);
    } else if (bodyId === 'LogoffFin') {
        LogoffFin();
    }


    // 会員登録フローガイド
    $('.flow_guide').each(function () {
        let $firstFlow = $(this).find('li:first-child');
        if($firstFlow.text().indexOf('1.会員規約を確認') > -1) {
            $firstFlow.text('1.利用規約を確認');
        }
    });

    // フッターのプライバシーポリシーを別タブで開くようにする
    $('#cmnfoot_button_privacy').attr({target:"_blank", rel:"noopener noreferrer"});

    setTimeout(function () {
        // #cmnhead_button_helpのリンクを常にcom_helpにする
        $('#cmnhead_button_help').attr('href', '/v2/help/com_help.aspx?ccode=IOTS');
        // #cmnfoot_button_helpのリンクを常にcom_helpにする
        $('#cmnfoot_button_help').attr('href', '/v2/help/com_help.aspx?ccode=IOTS');

        // #cmnhead_button_contactのリンクを常にcom_contactにする
        $('#cmnhead_button_contact').attr('href', '/v2/help/com_contact.aspx?ccode=IOTS');

        // #cmnfoot_button_fckiyakuのリンクを常にcom_kiyakuにする
        $('#cmnfoot_button_fckiyaku').attr('href', '/v2/help/com_kiyaku.aspx?ccode=IOTS');
    }, 100);

});

// Register
function pageRegister() {
  $('.tblbody_email .table_control').prepend('<div class="mb-20"><a href="/v2/help/kiyaku.aspx?ccode=IOTS" target="_blank">【利用規約】</a>にご同意の上、メールアドレスを入力してください。</div>');
}

// RegisterStep1
function RegisterStep1() {
    $('.link_ec').each(function () {
        if($(this).text().indexOf('会員規約') > -1) {
            $(this).text('利用規約');
        }
    });

    $('.table_label.col_must').each(function(){
        let $title = $(this);

        if($title.text().indexOf('郵便番号') > -1) {
            $title.append('<div class="c-red">※ハイフンなしの半角数字で入力してください。</div>');
        }
    });
}

// MyPage
function MyPage() {
  // アコーディオンを開いておく
  $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
  $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
  $('.table_collapse').addClass('in');

  setTimeout(function () {
    // #fcRegister_lnkがあったら削除
    if($('#fcRegister_lnk').length) {
        $('#fcRegister_lnk').remove();
    }
    // .fcregister_link2があったら削除
    if($('.fcregister_link2').length) {
        $('.fcregister_link2').remove();
    }
    }, 100);
}

// fcJoinEntry
function fcJoinEntry() {
  $('.link_fc').each(function () {
    if($(this).text().indexOf('会員規約') > -1) {
        $(this).text('利用規約');
    }
  });

    // .freeitem_box_512（月額-ニックネーム）があればその内容をcloneして.tblbody_cust_genderの前に挿入し、もともとの.freeitem_box_512は削除する
    if($('#fcFreeItemPanel .freeitem_box_512').length) {
        $('#fcFreeItemPanel .freeitem_box_512').clone().insertBefore('.tblbody_cust_gender');
        $('#fcFreeItemPanel .freeitem_box_512').remove();
        // #panel_fcpayfreeitemの.freetable_controlが一つもなければ#panel_fcpayfreeitemを削除する
        if(!$('#fcFreeItemPanel .freetable_control').length) {
            $('#fcFreeItemPanel').remove();
        }
    }
}

// fcPay
function fcPay() {
    // .freeitem_box_512（月額-ニックネーム）があればその内容をcloneして.tblbody_cust_genderの前に挿入し、もともとの.freeitem_box_512は削除する
    if($('#fcFreeItemPanel .freeitem_box_512').length) {
        if($('.tblbody_cust_gender').length) {
            $('#fcFreeItemPanel .freeitem_box_512').clone().insertBefore('.tblbody_cust_gender');
            $('#fcFreeItemPanel .freeitem_box_512').remove();
        } else if($('.tblbody_pay_method').length) {
            $('#fcFreeItemPanel .freeitem_box_512').clone().insertBefore('.tblbody_pay_method');
            $('#fcFreeItemPanel .freeitem_box_512').remove();
        }
        // #panel_fcpayfreeitemの.freetable_controlが一つもなければ#panel_fcpayfreeitemを削除する
        if(!$('#fcFreeItemPanel .freetable_control').length) {
            $('#fcFreeItemPanel').remove();
        }
    }
}

// com_help
function com_help() {
  $('.t_title').each(function () {
      if ($(this).text().indexOf('利用ガイド') > -1) {
          $(this).text('FAQ');
      }
  });

  $('.link_ec').each(function () {
    if ($(this).text().indexOf('通販に関するご利用ガイドはこちら') > -1) {
        $(this).text('OFFICIAL SHOPに関するFAQはこちら');
    }
});
$('.link_fc').each(function () {
    if ($(this).text().indexOf('ファンクラブに関するご利用ガイドはこちら') > -1) {
        $(this).text('I OF THE STORMに関するFAQはこちら');
        $(this).attr('href', 'https://fc.alanabe.com/faq/');
    }
});
  //- #form1の最後に月額サイト用のFAQリンクを追加
  $('#form1').append(''+
      '<div class="col-xs-12 com_panel">'+
          '<div class="panel panel-default">'+
              '<div class="panel-body">'+
                  '<a id="fc_m_lnk" class="link_fc" href="https://storming.alanabe.com/faq">Stormingに関するFAQはこちら</a>'+
              '</div>'+
          '</div>'+
      '</div>'
  );
}
function com_tokutei() {
    $('.link_ec').each(function () {
        if ($(this).text().indexOf('通販に関する特定商取引に関する法律に基づく表示はこちら') > -1) {
            $(this).text('OFFICIAL SHOPに関する特定商取引法に基づく表示はこちら');
        }
    });

    $('.link_fc').each(function () {
        if ($(this).text().indexOf('ファンクラブに関する特定商取引法に基づく表示はこちら') > -1) {
            $(this).text('I OF THE STORMに関する特定商取引法に基づく表示はこちら');
            $(this).attr('href', '/v2/help/fc_tokutei.aspx?ccode=IOTS&fcm=IOTS');
        }
    });
    //- #form1の最後に月額サイト用の特定商取引法に基づく表示リンクを追加
    $('#form1').append(''+
        '<div class="col-xs-12 com_panel">'+
            '<div class="panel panel-default">'+
                '<div class="panel-body">'+
                    '<a id="fc_m_lnk" class="link_fc" href="/v2/help/fc_tokutei.aspx?ccode=IOTS&fcm=STMG">Stormingに関する特定商取引法に基づく表示はこちら</a>'+
                '</div>'+
            '</div>'+
        '</div>'
    );
}
// com_contact
function com_contact() {
    $('.link_ec').each(function () {
        if ($(this).text().indexOf('通販に関するお問合せはこちら') > -1) {
            $(this).text('OFFICIAL SHOPに関するお問い合せはこちら');
        }
    });

    $('.link_fc').each(function () {
        if ($(this).text().indexOf('ファンクラブに関するお問合せはこちら') > -1) {
            $(this).text('I OF THE STORM/Stormingに関するお問い合せはこちら');
        }
    });
}

// fcKiyaku
function fcKiyaku() {
    $('.t_message').each(function () {
        if($(this).text().indexOf('会員規約を必ずお読みいただき、同意した上でお申込み手続きをおこなってください。') > -1) {
            $(this).text('利用規約を必ずお読みいただき、同意した上でお申込み手続きをおこなってください。');
        }
    });

    $('.kiyaku_header').each(function () {
        if($(this).text().indexOf('会員規約') > -1) {
            $(this).text('利用規約');
        }
    });
}

// com_kiyaku
function com_kiyaku() {
    $('.link_ec').each(function () {
        if ($(this).text().indexOf('通販に関する利用規約はこちら') > -1) {
            $(this).text('OFFICIAL SHOPに関する利用規約はこちら');
        }
    });

    $('.link_fc').each(function () {
        if ($(this).text().indexOf('ファンクラブに関する会員規約はこちら') > -1) {
            $(this).text('I OF THE STORMに関する利用規約はこちら');
            $(this).attr('href', '/v2/help/fc_kiyaku.aspx?ccode=IOTS&fcm=IOTS');
        }
    });
    //- #form1の最後に月額サイト用の利用規約リンクを追加
    $('#form1').append(''+
        '<div class="col-xs-12 com_panel">'+
            '<div class="panel panel-default">'+
                '<div class="panel-body">'+
                    '<a id="fc_m_lnk" class="link_fc" href="/v2/help/fc_kiyaku.aspx?ccode=IOTS&fcm=STMG">Stormingに関する利用規約はこちら</a>'+
                '</div>'+
            '</div>'+
        '</div>'
    );
}

// contact
function contact() {
    $('.t_message').each(function () {
        if ($(this).text().indexOf('お電話でのお問い合わせ') > -1) {
            $(this).hide();
        }
    });
    $('.info_panel').hide();
}

// fc_contact
function fc_contact() {
    $('.t_message').each(function () {
        if ($(this).text().indexOf('お電話でのお問い合わせ') > -1) {
            $(this).hide();
        }
    });
    $('.info_panel').hide();
}

// CheckOut
function CheckOut() {
    $('.link_ec').each(function () {
        if ($(this).text().indexOf('会員規約') > -1) {
            $(this).text('利用規約');
        }
    });
}

// fcJoin
function fcJoin() {
    $('.kiyaku_header').each(function () {
        if($(this).text().indexOf('会員規約') > -1) {
            $(this).text('利用規約');
        }
    });
}

function help07() {
    $('.panel-body').each(function () {
        if ($(this).text().indexOf('会場受け取り') > -1) {
            $(this).html('カート内の全ての商品が会場受け取り可能な商品の場合、会場での受け取りが可能です。<br>'
            + 'なお、会場で受け取るためには会員ログインしてご注文いただく必要がございます。<br><br>'
            + '会場でのお受け取りには送料はかかりません。<br><br>'
            + 'お受け取り指定日時は、<a class="link_ec" href="/v2/member/OrderList.aspx?ccode=IOTS">マイページのご購入履歴</a>とメールにてご確認下さい。<br>'
            + 'ご注文後、ご指定の日時に会場の受け取り窓口までお越しください。'
            + '商品を受け取られなかった場合、ご注文はキャンセルとなりますのでご了承ください。'
            );
        }
    });
}

// kiyaku
function Kiyaku(pageId) {
  $('#kiyakuLabel').html(`<div style="position:relative;height: 60vh;border: #e4e4e4 solid 1px;"><iframe src="https://docs.axelentermedia.co.jp/kiyaku/${pageId}?textonly" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;padding-top: 10px;" frameborder="0" allowfullscreen></iframe></div>`);
}

// tokutei
function Tokutei(pageId) {
  $('#tokuteiLabel').html(`<div style="position:relative;height: 60vh;border: #e4e4e4 solid 1px;"><iframe src="https://docs.axelentermedia.co.jp/tokutei/${pageId}?textonly" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;padding-top: 10px;" frameborder="0" allowfullscreen></iframe></div>`);
}

function LogoffFin() {
    var targetElement = $('.finmsg_panel .alert-success');
    if (targetElement.length === 0) {
        console.log("指定のDOM要素が存在しません。");
    }
    else {
        targetElement.append(''+
            '<div style="margin-top:20px">I OF THE STORM：<a href="https://fc.alanabe.com/">https://fc.alanabe.com/</a></div>'+
            '<div>Storming：<a href="https://storming.alanabe.com/">https://storming.alanabe.com/</a></div>'+
            '<div>OFFICIAL SHOP：<a href="https://ec.alanabe.com/">https://ec.alanabe.com/</a></div>'+
        '');
    }
}